import QuoteSvg from '@/assets/quote.svg';

interface QuoteContent {
  quote?: string;
  pageTitle?: string;
  pageId?: number | string;
  preTitle?: string;
  expert?: {
    expertName?: string;
    jobTitle?: string;
  };
  backgroundColor?: string;
}

interface QuoteItemProps {
  content: QuoteContent;
  file: any;
  viewMode?: 'grid' | 'list';
}

const QuoteItem: React.FC<QuoteItemProps> = ({ content, viewMode = 'grid' }) => {
  if (viewMode === 'list') {
    return (
      <div className="flex h-[160px] items-center gap-4 border border-gray-200 bg-white">
        <div
          className="relative h-full w-[315px] cursor-pointer border-r border-gray-300 bg-gray-50 px-[21px] py-0"
          //onClick={handleClick}
        >
          <div className="relative flex h-full items-center justify-center p-0">
            <QuoteSvg
              className="absolute -top-[100px] -left-[140px] z-[2]"
              style={{ opacity: 0.05, transform: 'scale(0.15)', width: '300px', height: '300px', fill: '#000000' }}
            />
            <QuoteSvg
              className="absolute -right-[140px] -bottom-[100px] z-[2]"
              style={{
                opacity: 0.05,
                transform: 'rotate(180deg) scale(0.15)',
                width: '300px',
                height: '300px',
                fill: '#000000',
              }}
            />
            <div className="relative z-[3] line-clamp-4 overflow-hidden text-left text-[16px] text-black">
              {content?.quote}
            </div>
          </div>
        </div>
        <div
          className="relative bottom-10 flex-1 cursor-pointer"
          //onClick={handleClick}
        >
          <h4 className="font-bold text-gray-900">Quote</h4>
          <div className="mt-1 text-xs text-black">
            <div className="line-clamp-3 overflow-hidden">{content?.pageTitle}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div
        className="cntr relative h-0 w-full cursor-pointer overflow-hidden border border-gray-300 bg-gray-50 pt-[30px]"
        style={{ paddingBottom: '73.25%' }}
        //onClick={handleClick}
      >
        <QuoteSvg
          className="absolute -top-[42px] -left-[53px] z-[2]"
          style={{ opacity: 0.05, transform: 'scale(0.3)', width: '174px', height: '147px', fill: '#000000' }}
        />
        <QuoteSvg
          className="absolute -right-[51px] -bottom-[39px] z-[2]"
          style={{
            opacity: 0.05,
            transform: 'rotate(180deg) scale(0.3)',
            width: '174px',
            height: '147px',
            fill: '#000000',
          }}
        />
        <div className="absolute top-4 right-4 bottom-4 left-4">
          <div className="extractContent relative h-full w-full">
            <div className="description absolute top-3 z-[3] line-clamp-6 overflow-hidden text-left text-[16px] text-black">
              {content?.quote}
            </div>
          </div>
        </div>
      </div>
      <div className="ifno h-[120px] border border-t-0 border-gray-300 bg-white p-3">
        <h4 className="text-sm font-bold">Quote</h4>
        <div className="lnk mt-1 text-xs">{content?.pageTitle}</div>
      </div>
    </div>
  );
};

export default QuoteItem;
